const destinations = [['explore','Explore'],['tonight','Tonight'],['solar','Solar'],['events','Events']];
export default function DestinationNav({current,onSelect}) {
  return <nav className="og-destinations" aria-label="Primary navigation">{destinations.map(([id,label])=><button key={id} aria-current={current===id?'page':undefined} onClick={()=>onSelect(id)}>{label}</button>)}</nav>;
}
